import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { CommoditySqlView } from 'shared/types';
import { formatDateWithTime } from 'shared/utility';

export function DisplayDate(params: GridRenderCellParams<string, CommoditySqlView>) {
  const formattedDate = params.value ? formatDateWithTime(new Date(params.value as string)) : '';

  return <Typography variant='body2'>{formattedDate}</Typography>;
}
